<template>
  <div id="atmObstHstrMain" class="container">
    <main class="main-content">
      <article class="main">
        <QuickLink />
      </article>
      <article class="sub" style="padding-top: 0; padding-right: 0.5rem; padding-left: 0.5rem;">
        <div id="main_srch_area" class="srch_area">
          <div class="grid-container">
            <div style="line-height: 35px;">
              배송처코드:
            </div>
            <div style="grid-column: 2 / -1;">
              <DxTextBox
                fontSize="20px"
                height="35px"
                v-model="dlvdId"
                :onEnterKey="handleSrchClick"
              />
            </div>
          </div>
          <div style="margin-bottom: 10px;">
            <div style="display: flex; justify-content: space-between;">
              <button
                class="btn btn_type_01 font13"
                @click="handleListClick"
              >
                등록한 목록
              </button>
              <button
                class="btn btn_type_01 font13"
                @click="handleSrchClick"
              >
                ATM 조회
              </button>
              <button
                class="btn btn_type_01 font13"
                @click="handleOpenAtmClick"
              >
                등록
              </button>
            </div>
          </div>
        </div>
        <div class="tbl font20" style="max-height: 448px; overflow: auto;">
          <div
            v-for="(atmInfo, atmIdx) in atmList"
            :key="`atmInfo-${atmIdx}`"
            class="border-top"
            @click.prevent="e => handleItemCheckClick(atmIdx)"
          >
            <div class="grid-list-container">
              <div class="grid-item disp-flex checkbox-div-align">
                <input
                  type="checkBox"
                  :id="`check_${atmIdx}`"
                  :checked="checkValList[atmIdx]"
                />
                <label :for="`check_${atmIdx}`"></label>
              </div>
              <div class="grid-atm-name">
                {{ atmInfo.atm_name }}
              </div>
            </div>
          </div>
        </div>
      </article>
    </main>
    <AtmObstHstrListModal ref="atmObstHstrListModal" @jobCheck="handleListClick" @close="isOpenModal = false"/>
  </div>
</template>

<script>
import QuickLink from '@/components/QuickLink.vue'
import DxTextBox from 'devextreme-vue/text-box'
import AtmObstHstrListModal from './AtmObstHstrListModal.vue'
import AtmObstHstrInsert from './AtmObstHstrInsert.vue'
import AtmObstHstr from './AtmObstHstr.vue'

export default {
  name: 'AtmObstHstrMain',
  components: {
    QuickLink,
    DxTextBox,
    AtmObstHstrListModal
  },
  data: () => ({
    dlvdId: '',
    atmList: [],
    checkValList: [],
    isOpenModal: false
  }),
  computed: {
    checkedItemIdx () {
      return this.checkValList.findIndex(val => val)
    },
    targetAtmInfo () {
      if (this.checkedItemIdx === -1) {
        return {}
      }
      return this.atmList[this.checkedItemIdx]
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {

  },
  methods: {
    goMenu (menuUrlAddr) {
      this.$router.push({path: menuUrlAddr})
    },
    handleListClick () {
      this.isOpenModal = true
      this.$modal.show('atmObstHstrListModal', { comp: AtmObstHstr, title: 'ATM 이상신고 목록', propData: { isModal: true } })
    },
    async handleSrchClick () {
      if (!this.dlvdId) {
        return
      }
      const res = await this.$http.get(`/api/purchase/customerCare/atm/${this.dlvdId}`)

      if (res) {
        const { data: { result, status } } = res
        if (status === '200') {
          this.atmList = result
          this.checkValList = result.map(_obj => false)
        }
      }
    },
    handleOpenAtmClick () {
      if (this.checkedItemIdx === -1) {
        this.$Alert.alert('대상 ATM을 선택해 주세요.')
        return
      }

      this.isOpenModal = true
      this.$modal.show('atmObstHstrListModal', { comp: AtmObstHstrInsert, title: 'ATM 이상신고', propData: { propAtmInfo: this.targetAtmInfo, isModal: true } })

      // this.$router.push({ name: 'AtmObstHstrInsert', params: { atmInfo: this.targetAtmInfo } })
    },
    handleItemCheckClick (trgtIdx) {
      this.checkValList = this.checkValList.map((val, idx) => {
        if (idx === trgtIdx) {
          return !val
        }
        return false
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isOpenModal) {
      this.isOpenModal = false
      this.$refs.atmObstHstrListModal.close()
      if (to.path === '/customerCare/atmObstHstrInsert') {
        next()
      }
      next(false)
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 10px;
    margin-bottom: 10px;
}
.grid-list-container {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 10px;
    margin-bottom: 10px;
}
  .grid-item {
    padding: 2px;
    text-align: center;
  }
  .grid-atm-name {
    grid-column: 2 / -1;
    line-height: 34px;
  }
  .disp-flex {
    display: flex;
  }
  .checkbox-div-align {
    justify-content: center;
    align-items: center;
  }
  .border-top {
    border-top: 1px solid #ccc;
  }
  input[type="checkbox"]{
    display: none;
  }
  input[type="checkbox"] + label{
    display: inline-block;
    width: 30px;
    height: 30px;
    border:3px solid #707070;
    position: relative;
  }
  input[type="checkbox"]:checked + label::after{
    content:'✔';
    font-size: 25px;
    width: 30px;
    height: 30px;
    text-align: center;
    position: absolute;
    left: -3px;
    top: -6px;
    color: #2bd3c6;
  }
  .main .quick-link {
    height: 150px;
  }
</style>

<style>
#atmObstHstrMain #main_srch_area .dx-widget input {
  font-size: 20px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmObstHstrMain.vue